import casinoService from '../services/casino.service'
import type { CasinoGameRecord } from '../utils/lotusCasinoGameFilter'

export const LOTUS_CASINO_STALE_MS = 5 * 60_000
export const LOTUS_CASINO_GC_MS = 30 * 60_000

export type CasinoProviderTypePair = {
  provider: string
  type: string
}

export const lotusCasinoKeys = {
  all: ['lotusCasino'] as const,
  providerList: (provider: string, type: string, preLoginMode: boolean) =>
    [
      ...lotusCasinoKeys.all,
      'providerList',
      provider,
      type,
      preLoginMode ? 'public' : 'auth',
    ] as const,
  visibility: (preLoginMode: boolean) =>
    [...lotusCasinoKeys.all, 'visibility', preLoginMode ? 'public' : 'auth'] as const,
}

const LIVE_CASINO_PROVIDERS = new Set([
  'evolution live',
  'ezugi',
  'playtech',
  'sexy',
  'km',
  'kingmidas',
  'mac88',
  'mac88 gaming',
])

export function casinoTypesForProvider(providerId: string): string[] {
  if (LIVE_CASINO_PROVIDERS.has(providerId.toLowerCase())) {
    return ['slots', 'live-casino']
  }
  return ['slots']
}

export async function fetchCasinoProviderList(
  provider: string,
  type: string,
  preLoginMode: boolean,
): Promise<CasinoGameRecord[]> {
  const res = preLoginMode
    ? await casinoService.getPublicIntCasinoList(provider, type)
    : await casinoService.getIntCasinoList(provider, type)
  const list = (res as { data?: { result?: unknown } }).data?.result
  return Array.isArray(list) ? (list as CasinoGameRecord[]) : []
}

export function dedupeProviderTypePairs(
  pairs: CasinoProviderTypePair[],
): CasinoProviderTypePair[] {
  const seen = new Set<string>()
  const out: CasinoProviderTypePair[] = []
  for (const pair of pairs) {
    const key = `${pair.provider}\0${pair.type}`
    if (seen.has(key)) continue
    seen.add(key)
    out.push(pair)
  }
  return out
}
